module.exports = __webpack_public_path__ + "static/media/michigan.a6d1f13c.svg";